import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedLayout from '../wrappers/layout-wrapper';
import Conversation from '../../pages/conversation';

const useFullPageRoutes = () => (
  <Route element={<ProtectedLayout hideNav />}>
    <Route path="trip-matches/:tripMatchId/messages/:conversationId">
      <Route index element={<Conversation />} />
    </Route>
  </Route>
);

export default useFullPageRoutes;
